package com.zq.my_official_website

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import myofficialwebsite_master.composeapp.generated.resources.Res
import myofficialwebsite_master.composeapp.generated.resources.page_banner_about
import myofficialwebsite_master.composeapp.generated.resources.page_banner_partners
import myofficialwebsite_master.composeapp.generated.resources.page_banner_product_plan
import myofficialwebsite_master.composeapp.generated.resources.home_partners
import myofficialwebsite_master.composeapp.generated.resources.product_img_47969607
import myofficialwebsite_master.composeapp.generated.resources.product_img_47975940
import myofficialwebsite_master.composeapp.generated.resources.product_img_47976526
import myofficialwebsite_master.composeapp.generated.resources.product_img_47982729
import myofficialwebsite_master.composeapp.generated.resources.product_img_47984753
import myofficialwebsite_master.composeapp.generated.resources.product_img_47984795
import myofficialwebsite_master.composeapp.generated.resources.plan_img_47997490
import myofficialwebsite_master.composeapp.generated.resources.plan_img_47999078
import myofficialwebsite_master.composeapp.generated.resources.plan_img_47999217
import myofficialwebsite_master.composeapp.generated.resources.plan_img_47999777
import myofficialwebsite_master.composeapp.generated.resources.plan_img_48000113
import myofficialwebsite_master.composeapp.generated.resources.plan_img_48000301
import myofficialwebsite_master.composeapp.generated.resources.plan_img_48000625
import myofficialwebsite_master.composeapp.generated.resources.plan_img_48000653
import myofficialwebsite_master.composeapp.generated.resources.plan_img_48000767
import myofficialwebsite_master.composeapp.generated.resources.plan_img_48001871
import org.jetbrains.compose.resources.DrawableResource

@Composable
fun ProductPage(
    modifier: Modifier = Modifier,
    currentPage: SitePage,
    onNavigate: (SitePage) -> Unit,
) {
    SiteScaffold(
        modifier = modifier,
        currentPage = currentPage,
        onNavigate = onNavigate,
        hero = Res.drawable.page_banner_product_plan,
        title = "产品",
    ) { isCompact ->
        ImageStrip(
            isCompact = isCompact,
            images = listOf(
                Res.drawable.product_img_47975940,
                Res.drawable.product_img_47969607,
                Res.drawable.product_img_47976526,
                Res.drawable.product_img_47982729,
                Res.drawable.product_img_47984753,
                Res.drawable.product_img_47984795,
            )
        )
    }
}

@Composable
fun PlanPage(
    modifier: Modifier = Modifier,
    currentPage: SitePage,
    onNavigate: (SitePage) -> Unit,
) {
    SiteScaffold(
        modifier = modifier,
        currentPage = currentPage,
        onNavigate = onNavigate,
        hero = Res.drawable.page_banner_product_plan,
        title = "方案",
    ) { isCompact ->
        ImageStrip(
            isCompact = isCompact,
            images = listOf(
                Res.drawable.plan_img_47997490,
                Res.drawable.plan_img_47999078,
                Res.drawable.plan_img_47999217,
                Res.drawable.plan_img_47999777,
                Res.drawable.plan_img_48000113,
                Res.drawable.plan_img_48000301,
                Res.drawable.plan_img_48000625,
                Res.drawable.plan_img_48000653,
                Res.drawable.plan_img_48000767,
                Res.drawable.plan_img_48001871,
            )
        )
    }
}

@Composable
fun PartnersPage(
    modifier: Modifier = Modifier,
    currentPage: SitePage,
    onNavigate: (SitePage) -> Unit,
) {
    SiteScaffold(
        modifier = modifier,
        currentPage = currentPage,
        onNavigate = onNavigate,
        hero = Res.drawable.page_banner_partners,
        title = "合作伙伴",
    ) { isCompact ->
        val maxContentWidth = 1100.dp
        val padding = if (isCompact) 16.dp else 24.dp
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = padding),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            ResponsiveImage(
                res = Res.drawable.home_partners,
                contentDescription = "合作伙伴",
                modifier = Modifier
                    .width(maxContentWidth)
                    .fillMaxWidth(),
                contentScale = ContentScale.Crop
            )
        }
    }
}

@Composable
fun AboutPage(
    modifier: Modifier = Modifier,
    currentPage: SitePage,
    onNavigate: (SitePage) -> Unit,
) {
    SiteScaffold(
        modifier = modifier,
        currentPage = currentPage,
        onNavigate = onNavigate,
        hero = Res.drawable.page_banner_about,
        title = "关于我们",
    ) { _ ->
        AboutContactSection()
    }
}

@Composable
private fun SiteScaffold(
    modifier: Modifier,
    currentPage: SitePage,
    onNavigate: (SitePage) -> Unit,
    hero: DrawableResource,
    title: String,
    content: @Composable (isCompact: Boolean) -> Unit,
) {
    val scroll = rememberScrollState()

    Surface(modifier = modifier) {
        BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
            val isCompact = maxWidth < 900.dp
            val pageBg = Color(0xFFF7F8FB)

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(scroll)
                    .background(pageBg)
            ) {
                TopNav(
                    isCompact = isCompact,
                    selectedIndex = currentPage.toTopNavIndex(),
                    onSelect = { onNavigate(sitePageFromTopNavIndex(it)) }
                )

                PageHero(hero = hero, title = title, isCompact = isCompact)

                content(isCompact)

                Spacer(Modifier.height(64.dp))
                Footer(isCompact = isCompact)
            }
        }
    }
}

@Composable
private fun PageHero(hero: DrawableResource, title: String, isCompact: Boolean) {
    val h = if (isCompact) 260.dp else 360.dp
    BoxWithConstraints(
        modifier = Modifier
            .fillMaxWidth()
            .height(h),
        contentAlignment = Alignment.Center
    ) {
        ResponsiveImage(
            res = hero,
            contentDescription = title,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            AppText(
                title,
                color = Color.White,
                fontSize = if (isCompact) 34.sp else 44.sp,
                fontWeight = FontWeight.Bold
            )
            Spacer(Modifier.height(8.dp))
            AppText(
                "专注为大中型企业,结合Ai与鸿蒙为公司",
                color = Color.White,
                fontSize = if (isCompact) 14.sp else 16.sp,
                textAlign = TextAlign.Center
            )
        }
    }
}

@Composable
private fun ImageStrip(isCompact: Boolean, images: List<DrawableResource>) {
    val maxContentWidth = 1100.dp
    val padding = if (isCompact) 16.dp else 24.dp

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = padding),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        images.forEach { res ->
            Spacer(Modifier.height(18.dp))
            ResponsiveImage(
                res = res,
                contentDescription = null,
                modifier = Modifier
                    .width(maxContentWidth)
                    .fillMaxWidth(),
                contentScale = ContentScale.Fit
            )
        }
    }
}

@Composable
private fun AboutContactSection() {
    val uriHandler = LocalUriHandler.current
    val maxContentWidth = 1100.dp

    val address = "深圳市南山区粤海街道高新区社区高新南九道59号北科大厦4楼435B"
    val phone = "18320985107"

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 32.dp, bottom = 8.dp, start = 16.dp, end = 16.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle("联系我们", topPadding = 0.dp)
        Spacer(Modifier.height(18.dp))

        BoxWithConstraints(
            modifier = Modifier
                .widthIn(max = maxContentWidth)
                .fillMaxWidth()
        ) {
            val isCompact = maxWidth < 900.dp
            val openMap = { uriHandler.openUri(buildMapUrl(address)) }
            val isWeb = runCatching { getPlatform().name }.getOrNull()?.startsWith("Web") == true

            if (!isCompact) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.Top
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        AppText(
                            "深圳智启万物科技有限公司",
                            color = Color(0xFF222222),
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold
                        )
                        Spacer(Modifier.height(12.dp))
                        AppText(
                            "公司地址：$address",
                            color = Color(0xFF444444),
                            fontSize = 16.sp,
                            lineHeight = 26.sp
                        )
                        AppText(
                            "服务热线：$phone",
                            color = Color(0xFF444444),
                            fontSize = 16.sp,
                            lineHeight = 26.sp
                        )
                    }

                    Spacer(Modifier.width(18.dp))

                    if (isWeb) {
                        Column(modifier = Modifier.weight(1f)) {
                            AboutPageBaiduMiniMap(
                                address = address,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(220.dp),
                            )
                            Spacer(Modifier.height(8.dp))
                            AppText(
                                "在完整页面查看 / 操作地图",
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clickable(onClick = openMap),
                                fontSize = 14.sp,
                                color = Color(0xFF2563EB),
                                textAlign = TextAlign.Center,
                            )
                        }
                    } else {
                        MapCard(
                            modifier = Modifier.weight(1f),
                            onOpenMap = openMap,
                        )
                    }
                }
            } else {
                Column(modifier = Modifier.fillMaxWidth()) {
                    AppText(
                        "深圳智启万物科技有限公司",
                        color = Color(0xFF222222),
                        fontSize = 18.sp,
                        fontWeight = FontWeight.Bold
                    )
                    Spacer(Modifier.height(12.dp))
                    AppText(
                        "公司地址：$address",
                        color = Color(0xFF444444),
                        fontSize = 16.sp,
                        lineHeight = 26.sp
                    )
                    AppText(
                        "服务热线：$phone",
                        color = Color(0xFF444444),
                        fontSize = 16.sp,
                        lineHeight = 26.sp
                    )

                    Spacer(Modifier.height(16.dp))
                    if (isWeb) {
                        AboutPageBaiduMiniMap(
                            address = address,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(220.dp),
                        )
                        Spacer(Modifier.height(8.dp))
                        AppText(
                            "在完整页面查看 / 操作地图",
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable(onClick = openMap),
                            fontSize = 14.sp,
                            color = Color(0xFF2563EB),
                            textAlign = TextAlign.Center,
                        )
                    } else {
                        MapCard(
                            modifier = Modifier.fillMaxWidth(),
                            onOpenMap = openMap,
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun MapCard(
    modifier: Modifier,
    onOpenMap: () -> Unit,
) {
    Column(
        modifier = modifier
            .height(400.dp)
            .border(1.dp, Color(0xFFE7E9EE))
            .background(Color(0xFFF7F8FB))
            .clickable(onClick = onOpenMap)
            .padding(16.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        AppText(
            "地图",
            fontSize = 16.sp,
            fontWeight = FontWeight.SemiBold,
            color = Color(0xFF111827)
        )
        Spacer(Modifier.height(10.dp))
        AppText(
            "点击打开百度地图查看位置",
            fontSize = 14.sp,
            color = Color(0xFF4B5563),
            textAlign = TextAlign.Center
        )
    }
}

private fun buildBaiduSearchUrl(address: String): String {
    // 避免在 Wasm/JS 使用 java.net.URLEncoder；百度地图对中文查询参数通常可直接处理
    return "https://map.baidu.com/?newmap=1&qt=s&wd=$address"
}

private fun buildMapUrl(address: String): String {
    // Web 端：打开站内 map.html，页面内用 iframe 显示地图（更接近 gywm.html 的效果）
    // 非 Web 端：先用百度地图搜索页兜底；等你后续加 Key 后再做更原生的地图展示
    val platform = runCatching { getPlatform().name }.getOrNull().orEmpty()
    return if (platform.startsWith("Web")) {
        "/map.html?address=${percentEncodeQueryComponent(address)}"
    } else {
        buildBaiduSearchUrl(address)
    }
}

